import React from 'react';
import Header from '../../ReuseableComponents/Header';
import Footer from '../../ReuseableComponents/Footer';
import HomeContent from './HomeContent';
import '../../Assests/Css/style.css';

const HomePage = () => {

    return (
        <div className='HomePage'>
            <Header />
            <HomeContent />
            <Footer />
        </div>
    )
}

export default HomePage;